import { render, staticRenderFns } from "./DragPanel.vue?vue&type=template&id=e8bfbc2e&scoped=true"
import script from "./DragPanel.vue?vue&type=script&lang=js"
export * from "./DragPanel.vue?vue&type=script&lang=js"
import style0 from "./DragPanel.vue?vue&type=style&index=0&id=e8bfbc2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8bfbc2e",
  null
  
)

export default component.exports